import { CHAIN_IDS } from 'utils/wagmi'
import Swap from 'views/Swap'
import SwapLayout from 'views/Swap/SwapLayout'

const IndexPage = () => (
  <SwapLayout>
    <Swap />
  </SwapLayout>
)

IndexPage.chains = CHAIN_IDS
IndexPage.screen = true

export default IndexPage
